import { useState } from 'react';
import useTodaysVideoCalls from './useTodaysVideoCalls';
import VideoCallNotification from './VideoCallNotification';

const VideoCallsNotificationPanel = () => {
  const { videoCalls } = useTodaysVideoCalls();
  const [showAllVideoCalls, setShowAllVideoCalls] = useState(false);

  const handleMoreButtonClick = () => {
    setShowAllVideoCalls(!showAllVideoCalls);
  };

  return videoCalls?.map((videoCall, index) => (
    showAllVideoCalls || index === 0 ? (
      <VideoCallNotification
        key={`video-call-${videoCall.id}`}
        videoCall={videoCall}
        onMoreButtonClick={index === 0 && videoCalls?.length > 1 ? handleMoreButtonClick : null}
        showAllVideoCalls={showAllVideoCalls}
      />
    ) : null)
  );
};

export default VideoCallsNotificationPanel;

